import { createSelector } from '@reduxjs/toolkit';

import type { RootState } from '@/store';

const selectAutosState = (state: RootState) => state.advogadoAutos;

export const selectAutosAdvogado = (state: RootState) => selectAutosState(state).autos;
const selectAutosAdvogadoStatus = (state: RootState) => selectAutosState(state).autosStatus;
export const selectAndamentosAdvogado = (state: RootState) => selectAutosState(state).andamentos;
export const selectDocumentosAdvogado = (state: RootState) => selectAutosState(state).documentos;
export const selectPendenciasAdvogado = (state: RootState) => selectAutosState(state).pendencias;
export const selectMensagensChatAdvogado = (state: RootState) =>
  selectAutosState(state).mensagensChat;
export const selectSolicitacoesAdvogado = (state: RootState) =>
  selectAutosState(state).solicitacoes;

export const selectCarregandoAutosAdvogado = createSelector(
  [selectAutosAdvogadoStatus],
  (status) => status === 'idle' || status === 'loading',
);

export const selectAutosAdvogadoFalhou = createSelector(
  [selectAutosAdvogadoStatus],
  (status) => status === 'failed',
);

export const selectErroAutosAdvogado = (state: RootState) => selectAutosState(state).autosErro;

export const selectSubmittingAndamentoAdvogado = (state: RootState) =>
  selectAutosState(state).submittingAndamento;
export const selectSubmittingSolicitacaoAdvogado = (state: RootState) =>
  selectAutosState(state).submittingSolicitacao;
export const selectSubmittingPendenciaAdvogado = (state: RootState) =>
  selectAutosState(state).submittingPendenciaId;
export const selectEnviandoMensagemAdvogado = (state: RootState) =>
  selectAutosState(state).enviandoMensagem;
export const selectCarregandoAndamentosAdvogado = (state: RootState) =>
  selectAutosState(state).andamentosStatus === 'loading';
export const selectCarregandoDocumentosAdvogado = (state: RootState) =>
  selectAutosState(state).documentosStatus === 'loading';
